import React from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider, useMsal } from '@azure/msal-react';
import { microsoftClientId } from '../../config/constants';
import microsoftLogo from '../../assets/img/Microsoft.png';

interface Props {
    // signIn: (provider: string, data: any) => void;
    signIn: any;
    label?: string;
}

const msalConfig = {
    auth: {
        clientId: microsoftClientId, // Replace with your actual Client ID
        // authority: 'https://login.microsoftonline.com/common', // Multi-tenant apps
        redirectUri: window.location.origin,
    },
};

const msalInstance = new PublicClientApplication(msalConfig);

const MicrosoftLoginComponent: React.FC<Props> = ({ signIn, label }) => {
    const { instance } = useMsal();

    const handleLogin = async () => {
        try {
            const response = await instance.loginPopup({
                scopes: ['openid', 'profile', 'email', 'User.Read'],
                prompt: 'select_account',
            });

            if (response?.account) {
                instance.setActiveAccount(response.account);
            }

            const email =
                response.account?.username ||
                (response.account?.idTokenClaims as any)?.email;

            signIn('microsoft', {
                id_token: response.idToken,
                email,
                ...response.account,
            });
        } catch (error: any) {
            // Popup blocked / new account → redirect fallback
            if (error?.errorCode === 'popup_window_error') {
                instance.loginRedirect({
                    scopes: ['openid', 'profile', 'email', 'User.Read'],
                    prompt: 'select_account',
                });
            } else {
                console.error('Microsoft Login Failed:', error);
            }
        }
    };

    return (
        <button
            onClick={handleLogin}
            className="btn login-btn microsoft-btn pointer-events-all text-center w-100"
        >
            <span className="microsoft-icon">
                <img loading="lazy" src={microsoftLogo} width={20} alt="Microsoft logo" />
            </span>
            <span className="social-btn-text">{label}</span>
        </button>
    );
};

const MicrosoftAuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <MsalProvider instance={msalInstance}>{children}</MsalProvider>
);

export { MicrosoftLoginComponent, MicrosoftAuthProvider };
